import { render, staticRenderFns } from "./SurfacePostAttachmentButton.vue?vue&type=template&id=3d93c797&"
import script from "./SurfacePostAttachmentButton.vue?vue&type=script&lang=ts&"
export * from "./SurfacePostAttachmentButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports